import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import HardwareRiport from '../../../../views/HardwareRiport/HardwareRiport';

const NewIncomeRoute = () => {
	return (
		<Routes>
			<Route path="" element={<HardwareRiport />} />			
		</Routes>
	);
};

export default NewIncomeRoute;
